export async function apiFollowUser(userId: number, token: string) {
  return fetch(process.env.REACT_APP_SERVER_URL + `/follow/follow-user?userId=${userId}`, {
    method: 'POST',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }).then(res => {
    if (!res.ok) throw new Error('Failed to follow');
    return res.json();
  });
}

export async function apiUnfollowUser(userId: number, token: string) {
  return fetch(process.env.REACT_APP_SERVER_URL + `/follow/un-follow-user?userId=${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  }).then(res => {
    if (!res.ok) throw new Error('Failed to unfollow');
    return res.json();
  });
}